import { CallCalling as CallCalling_kojaro } from './CallCalling.kojaro';
import { CallCalling as CallCalling_phosphor } from './CallCalling.phosphor';
import { CallCalling as CallCalling_zoomg } from './CallCalling.zoomg';
import { CallCalling as CallCalling_zoomit } from './CallCalling.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return CallCalling_kojaro;

    case 'zoomg':
      return CallCalling_zoomg;

    case 'phosphor':
      return CallCalling_phosphor;

    default:
      return CallCalling_zoomit;
  }
};

export const CallCalling = IconRenderer();
